import React, { useEffect } from 'react';

import { Nav } from '../components/Nav';
import { Footer } from '../components/Footer';
import { MetaTagsComponent } from '../components/MetaTags';

const ThankYou = () => {
  useEffect(() => {
    if (window.gtag) {
      window.gtag('event', 'conversion', {
        send_to: 'AW-10829471889/7618270039',
      });
    }
  }, []);

  return (
    <>
      <MetaTagsComponent lang="en" />
      <Nav />
      <section id='thank-you'>
        <div className='container tc'>
          <div className='s-80'></div>
          <h1 className='title-intro'>
            Thank You!
          </h1>
          <div className='s-48'></div>
          <a href='/' className='button'>
            Return to Homepage
          </a>
          <div className='s-80'></div>
        </div>
      </section>
      <Footer />
    </>
  );
};

export { ThankYou };